<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
        </v-overlay>

    <qr-edit-gateway
      v-model="showGatewayPopup"
      :sections="specialInfoSingle"
      :form-data="data"
      @edit-all="handleEditAll"
      @save="qrUpdate(true)"
      @cancel="onCancel"
    >
    <template v-slot:preview style="position: relative; min-height: 100%;">
      <div class="sticky-preview">
        <component
          :is="theme"
          v-model="data"
          :data="data"
          :orders.sync="orders"
          :key="currentEditingLang + '-' + theme"
          :qr-svg-data-url="qrSvgDataUrl"
        />
        </div>
      </template>
    </qr-edit-gateway>

      <v-row class="mx-auto pa-2" no-gutters  v-if="!showGatewayPopup">
        <v-col class="pa-2" cols="12">
          <v-progress-linear v-show="loading" height="5" indeterminate />
        </v-col>

        <v-col class="pa-2" cols="12" md="4" style="position: relative; min-height: 100%;">
        <div class="sticky-preview">
          <component
            :is="theme"
            v-model="data"
            :data="data"
            :orders.sync="orders"
            class="sticky-md"
            style="top: 110px"
            :qr-svg-data-url="qrSvgDataUrl"
          />
          </div>
        </v-col>

        <v-col class="pa-2" cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row">
                  <div class="col-md-12">
                    <p>{{ $t("enter_visit_card_pro_info") }}</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="res.title"
                        :error-messages="errors['title']"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        :label="$t('visit_card_name_pro')"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-Qr-res-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('visit_card_name_label')"
                      />
                    </div>
                  </div>

                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <qr-address-field
                        v-model="res.identifier"
                        :domain-id="res?.domain_id"
                        append-icon="mdi-web"
                        class="mt-0 pt-0 contentinfo"
                        dense
                        :key="$t('qrAddressUpdate.hints.allowedChars')"
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"
                        outlined
                        persistent-hint
                        readonly
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-Qr-res-identifier`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('qr_address')"
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                  <div class="d-flex flex-row align-center justify-space-between mb-4">
                    <v-alert
                      dense
                      outlined
                      type="info"
                      class="mb-0 flex-grow-1 ml-4 text-body-2"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </v-alert>

                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink text-body-3"
                      hide-details

                      label="ذخیره خودکار"
                    ></v-switch>
                  </div>

                <list-expansion
                  flat
                  icon="pencil-ruler"
                  single
                  :title="$t('select_template_design')"
                  :data="data"
                  @save-required="AutoSave && qrUpdate(false)"

                >
                  <template v-slot:content>
                    <theme-selector v-model="theme" :components="customTheme" />
                  </template>
                </list-expansion>
                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :data="data"
                  @save-required="AutoSave && qrUpdate(false)"

                />
                <qr-generator v-model="data" @save-required="AutoSave && qrUpdate(false)"/>

                <div class="col-md-12">
                  <next-btn :loading="loading" @click="qrUpdate(true)" />
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: $t('download') }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('download')"
            />
          </template>
          <v-card class="pa-5">
              <download-file-with-api
              v-if="showDialog"
              :address="`${res?.domain?.name||'qrland.in/'}${res.identifier}`"
              :qr_id="res.qrId"
              :visit-name="res.title"
              link
              @close="showDialog = false"
            />
          </v-card>
        </custom-popup>
        <translate-language-loader-v-2 :color="'#D4AF37' || '#ff1d5e'" />
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { Bus, debounce } from "@/main";
import MobileViwer from "./components/mobileViwer";
import QrGenerator from "./components/qrGenerator";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrManagement from "./components/qrManage/qrManagement";
import TextCards from "@/view/pages/qrland/components/textCards";
import QrAddressField from "../../content/fragments/qrAddressField";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import ThemeSelector from "./components/themes/themeSelector";
import VisitThemeTwo from "./components/themes/visitThemeTwo";
import VisitThemeFlipped from "./components/themes/visitThemeFlipped";
import { mapActions, mapGetters } from "vuex";
import { getLanguageCookie } from "../../../core/plugins/TitleRibbon/utils/languageCookie";
import TranslateLanguageLoaderV2 from "../otherQrTypes/luckWheel/TranslateLanguageLoaderV2.vue";
import { setDragging } from "@/utilities/DraggingKeysOrder";
import transitions from "vuetify/lib/components/transitions";
import DownloadFileWithApi from "./downloadFileWithApi.vue";
import QrEditGateway from "./components/QrEditGateway.vue";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "editVisitPro",
  components: {
    ThemeSelector,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrAddressField,
    DownloadFileWithApi,
    TextCards,
    QrManagement,
    QrCustomize,
    QrGenerator,
    MobileViwer,
    VisitThemeTwo,
    VisitThemeFlipped,
    TranslateLanguageLoaderV2,
    QrEditGateway,
    AtomSpinner
  },

  data() {
    return {
      qrSvgDataUrl:'',
      isAutoSaving: false, 
      AutoSave:false,
      showGatewayPopup: this.$route?.query?.gateway === 'true',
      currentEditingLang: "fa",
      serviceName: "Qrland",
      componentName: "editVisit",
      helpData: [],
      showDialog: false,
      data: {},
      errors: {},
      finish: false,
      loading: false,
      e6: 1,
      qrLink: "",
      security: {},
      dtUrl: null,
      theme: "",
      orders: [],
      customTheme: [
        { name: "MobileViwer", value: "" },
        { name: "VisitThemeTwo", value: "" },
        { name: "VisitThemeFlipped", value: "" },
      ],
      res: {},
    };
  },

  watch: {
    data: {
      deep: true,
      handler(newVal) {
        debounce(() => {
          this.setKeys(newVal);
          //  this.syncToMobileViewer();
        }, 250);
      },
    },

    currentEditingLang() {
      this.syncToMobileViewer();
    },
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    // theme(newTheme) {
    //   this.$root.$emit("visit-data-updated", {
    //     data: this.data,
    //     orders: this.orders,
    //     theme: newTheme,
    //     lang: this.currentLang,
    //   });
    // },
  },

  mounted() {
    this.$root.$on("mobile-viewer-updated", (payload) => {
      if (payload.lang === this.currentEditingLang) return;

      if (payload?.orders) {
        this.orders = [...payload?.orders];
      }
      if (payload?.data) {
        this.data = { ...payload?.data };
      }
      if (payload?.theme) {
        this.theme = payload?.theme;
      }
    });
    this.$root.$on("language-changed", ({ lang }) => {
      if (this.currentEditingLang === lang) return;
      this.currentEditingLang = lang;
    });
    Bus.$on("colorPalette", (value) => {
      this.data.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.data.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.data.isGradient = value;
    });

    Bus.$on("audioType", (value) => {});

    this.$root.$on("qrUpdate", (payload) => {
      this.qrUpdate(false);
      //this.saveToLangFtp(this.currentEditingLang, false, payload);
    });
    this.fetchData();
    this.$nextTick(() => {
      this.setKeys(this.data);
      //  this.syncToMobileViewer();
    });
  },
  destroyed() {
    this.$root.$off("language-changed");
  },
  computed: {
    ...mapGetters("localstorage", [
      "createQrID",
      "alllangs",
      "defaultLang",
      "mainDatalang",
    ]),
    specialInfo() {
      return [
        {
          name: "managmentLanguage",
          value: "",
          title: this.$t("language.management_langs"),
          subtitle: "",
          icon: "translate",
          model: "langs",
          mainData: this.data,
        },
        {
          name: "textCards",
          value: "",
          title: this.$t("user_info"),
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "customerClubSettings",
          title: this.$t("sms_membership_message"),
          icon: "cellphone-message",
          model: "customerClub",
        },
        {
          name: "advanceSettings",
          title: this.$t("smart_settings"),
          icon: "star-settings-outline",
          model: "advanceSettings",
        },
        {
          name: "voiceGallery",
          title: this.$t("add_audio_file"),
          icon: "microphone",
          model: "audiosGallery",
        },
           {
          name: "pdfSelector",
          value: "",
          title: this.$t("ROUTE.TITLES.QR_PDF"),
          subtitle: "",
          icon: "file-outline",
        },
        {
          name: "FeedBack",
          value: "",
          title: this.$t("feedback"),
          subtitle: "",
          icon: "reply-outline",
          model: "FeedBack",
        },
        {
          name: "consultationNew",
          value: "",
          title: this.$t("request_form"),
          subtitle: "",
          icon: "list-box-outline",
          model: "consultationNew",
        },
      ];
    },
  specialInfoSingle() {
  return [
    {
      name: "textCards",
      value: "",
      title: this.$t("user_info"),
      subtitle: "",
      icon: "account-outline",
      description: this.$t("special_info_desc.textCards"),
    },
    {
      name: "customerClubSettings",
      title: this.$t("sms_membership_message"),
      icon: "cellphone-message",
      model: "customerClub",
      description: this.$t("special_info_desc.customerClubSettings"),
    },
    {
      name: "advanceSettings",
      title: this.$t("smart_settings"),
      icon: "star-settings-outline",
      model: "advanceSettings",
      description: this.$t("special_info_desc.advanceSettings"),
    },
    {
      name: "voiceGallery",
      title: this.$t("add_audio_file"),
      icon: "microphone",
      model: "audiosGallery",
      description: this.$t("special_info_desc.voiceGallery"),
    },
    {
      name: "VideoGallery",
      value: "",
      title: this.$t("add_video"),
      subtitle: "",
      icon: "video-image",
      description: this.$t("special_info_desc.VideoGallery"),
      // model: 'video_single'
    },
    {
      name: "imageUploader",
      value: "",
      title: this.$t("add_image"),
      subtitle: "",
      icon: "cloud-upload-outline",
      model: "photo",
      description: this.$t("special_info_desc.imageUploader"),
    },
    {
      name: "colorPallete",
      value: "",
      title: this.$t("select_color"),
      subtitle: "",
      icon: "format-color-fill",
      model: "pallete",
      description: this.$t("special_info_desc.colorPallete"),
    },
    {
      name: "socialMediaIcons",
      value: "",
      title: this.$t("add_social_networks"),
      subtitle: "",
      icon: "instagram",
      model: "socialMedia",
      description: this.$t("special_info_desc.socialMediaIcons"),
    },
    {
      name: "pdfSelector",
      value: "",
      title: this.$t("ROUTE.TITLES.QR_PDF"),
      subtitle: "",
      icon: "file-outline",
      description: this.$t("special_info_desc.pdfSelector"),
    },
    {
      name: "FeedBack",
      value: "",
      title: this.$t("feedback"),
      subtitle: "",
      icon: "reply-outline",
      model: "FeedBack",
      description: this.$t("special_info_desc.FeedBack"),
    },
    {
      name: "consultationNew",
      value: "",
      title: this.$t("request_form"),
      subtitle: "",
      icon: "list-box-outline",
      model: "consultationNew",
      description: this.$t("special_info_desc.consultationNew"),
    },
  ];
},
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },
  created() {
    this.$root.$on("editvisit-lang-change", (lang) => {
      this.currentEditingLang = lang;
    });

    this.$root.$on("lang-data-loaded", ({ lang, data }) => {
      this.currentEditingLang = lang;
            
      let target = data;

      while (
        target && 
        target.data && 
        target.theme === undefined && 
        target.orders === undefined
      ) {
        target = target.data;
      }

      if (target && target.data && typeof target.data === 'object') {
        this.data = target.data;
      } else {
        this.data = target || {};
      }

      this.orders = target?.orders || [];
      this.theme = target?.theme || 'MobileViwer';

      this.$root.$emit("visit-data-updated", {
        data: {
          data: this.data, 
          orders: this.orders,
          theme: this.theme,
          lang: this.currentEditingLang, 
        },
      });
      this.$forceUpdate();
    });

    this.$root.$on("lang-maindata-updated", (data) => {
      this.data = { ...data };
    });
    this.currentEditingLang = this.defaultLang;
  },
    beforeDestroy(){
    // this.resetToDefaultLanguage();
  },

  methods: {
    ...mapActions("localstorage", [
      "setCreatedQrID",
      "setLangList",
      "setDefaultLang",
      "setMainData",
      "setCurrentLanguage"
    ]),
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId",
    ]),
        resetToDefaultLanguage() {
          const baseLang = this.defaultLang || 'fa';
          this.setCurrentLanguage(baseLang);          
          if (this.currentEditingLang) {
            this.currentEditingLang = baseLang;
          }
        },

    onCancel() {
      this.goto('qr/list');
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },
    setKeys(val = this.cardTexts) {
      let keys = setDragging(val, this.orders);
      if (
        val.audiosGallery &&
        val.audiosGallery.audios &&
        val.audiosGallery.audios.length > 0
      ) {
        const audioKeys = val.audiosGallery.audios.map((_, index) => ({
          name: `audio_${index}`,
        }));
        keys = [
          ...keys.filter((key) => !key.name.startsWith("audio_")),
          ...audioKeys,
        ];
      }

      keys = keys.filter((item) => item.name !== "audiosGallery");

      keys = keys.filter(
        (item) => item.name !== "langs" && item.name !== "language",
      );

      this.orders = keys;
      this.$forceUpdate();
    },

    syncToMobileViewer() {
      this.$root.$emit("visit-data-updated", {
        data: {
          data: JSON.parse(JSON.stringify(this.data)),
          orders: [...this.orders],
          theme: this.theme,
          lang: this.currentEditingLang,
        },
      });
    },
    // loadLangData(lang) {
    //   this.$api.get(`/langData?id=${this.qrId}&lang=${lang}`).then((res) => {
    //     const newData = res?.[0] || {};
    //     this.$root.$emit("visit-data-updated", {
    //       data: newData.data,
    //       orders: newData.orders || [],
    //       theme: newData.theme || "MobileViwer",
    //       lang: lang,
    //     });
    //   });
    // },
    fetchData() {
      this.loading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`,
        )
        .then(({ data }) => {
          this.setCreatedQrID(data?.data?.id);
          this.qrSvgDataUrl= data?.data?.img_url||''; 
          this.updateQrInfo(data.data);
          this.updateQridentifier(data.data.identifier);
          this.updateQrDomain(data.data.domain_id);
          this.updateQrId(data.data.id);

          this.setLangList(
            data?.data?.lang
              ?.split(",")
              ?.filter((l) => l !== data?.data?.default) || [],
          );
          this.setDefaultLang(data?.data?.default || "fa");
          let info = data.data.data;
          info.language =
            this.defaultLang || getLanguageCookie() || info?.language || "fa";
          this.currentEditingLang = info?.language;
          this.$root.$emit(
            "mobile-viewer-lang-change",
            this.currentEditingLang,
          );

          if (!!data.data?.data?.orders) {
            this.orders = data?.data?.data?.orders;
          } else {
            this.orders = [
                { name: "userName" },
                { name: "workField" },
                { name: "aboutUs" },
                { name: "extraFields" },
                { name: "video_gallery" },
                { name: "photo" },
                { name: "FeedBack" },
                { name : "consultation"},
                { name: "phoneNumber" },
                { name: "fax" },
                { name: "location" },
                { name: "codePostal" },
                { name: "email" },
                { name: "website" },
                { name: "audio_0" },
            ];
          }

          try {
            if (info.data?.coordinates) {
              info.data?.coordinates?.sort(function (a, b) {
                return b - a;
              });

              info.data?.center?.sort(function (a, b) {
                return b - a;
              });
            }
          } catch (e) {}
          if (info?.data?.photo) {
            info.data.photo = {
              ...info?.data?.photo,
              hasGame: false,
              hasGif: false,
            };
          }
          // // if (!info.data?.photo?.previewerQr) {
          // //   info.data.photo.previewerQr = {
          // //     previewer: {
          // //       gif: "",
          // //       game: {},
          // //       transition: "scale",
          // //     },
          // //   };
          // // }
          // if (!info.data?.photo?.previewerQr?.previewer) {
          //   info.data.photo.previewerQr.previewer = {
          //     gif: "",
          //     game: {},
          //     transition: "scale",
          //   };
          // }
          if (!info.data.video_gallery) {
            info.data.video_gallery = [{ name: "", images: [] }];
          }
          if (!info.data?.photo) {
            info.data.photo = {};
          }
          if (!info.data?.photo?.gallery)
            info.data.photo.gallery = [{ name: "", images: [] }];
          if (!info.data?.audiosGallery)
            info.data.audiosGallery = { audios: [], audioType: "newPlayer" };
          const defaultPicSelector = {
            slider: true,
            grid: false,
            orientation: 'horizontal'
          };

      if (info?.data?.photo?.PicSelector) {
        info.data.photo.PicSelector = {
          ...defaultPicSelector,
          ...info.data?.PicSelector,
          ...info.data?.photo?.PicSelector

        };
      } else {
        info.data.photo.PicSelector = { ...defaultPicSelector };
      }
          if (Array.isArray(info?.data?.audiosGallery)) {
            let audios =
              info?.data?.audiosGallery?.length > 0
                ? info?.data?.audiosGallery
                : [];
                
            audios = audios.map(audio => ({
              ...audio,
              autoPlay: audio.autoPlay || false,
            }));

            info.data.audiosGallery = {
              audios: audios,
              audioType: "newPlayer",
            };
          } 
          else if (info.data?.audiosGallery?.audios) {
            info.data.audiosGallery.audios = info.data.audiosGallery.audios.map(audio => ({
              ...audio,
              autoPlay: audio.autoPlay || false,
            }));
          }
          info.data.language =
            this.defaultLang ||
            getLanguageCookie() ||
            info.data.language ||
            "fa";
          info.data.langs = {
            source_lang:
              this.defaultLang || info.data.langs.source_lang || "fa",
            other_langs:
              this.alllangs?.map((x) => ({ lang: x, status: "edited" })) || [],
          };
          if (!info.data.pdf) info.data.pdf = null;
          if (!info.data.consultationNew)
            info.data.consultationNew = {
              title: "فرم درخواست",
              description: "",
              sectionColor: { backGround: "", text: "" },
              conform: false,
            };
      if (!!info.data.pdfSelector && !info.data.pdfSelector.layout) {
        info.data.pdfSelector = {
          ...info.data.pdfSelector,
          layout: "list",
        };
      }


          this.data = {
            ...info.data,
            langs: {
              source_lang:
                this.defaultLang || info.data.langs.source_lang || "fa",
              other_langs:
                this.alllangs?.map((x) => ({ lang: x, status: "edited" })) ||
                [],
            },
          };
          this.data = this.fixVideoGallery(info.data);
          if (info?.data?.theme && info?.data?.theme.length > 0) {
            this.theme = info?.data?.theme;
          } else if (info?.theme && info?.theme.length > 0) {
            this.theme = info?.theme;
          } else {
            this.theme = "MobileViwer";
          }
          // this.security = data.data.short_url;
          this.res = data.data;
          this.qrLink = data.data.link;
          this.res.language = this.default || getLanguageCookie() || "fa";
          this.$root.$emit("visit-data-updated", {
            data: {
              data: this.data,
              orders: this.orders,
              theme: this.theme,
              lang: this.data.language,
            },
          });
          this.setMainData({
            data: {
              data: this.data,
              orders: this.orders,
              theme: this.theme,
              lang: this.data.language,
            },
          });
        })
        .finally(() => {
          this.loading = false;
          this.$root.$emit("visit-data-updated", {
            data: {
              data: this.data || {},
              orders: this.orders,
              theme: this.theme,
              lang: this.currentEditingLang,
            },
          });
        });
    },

    fixVideoGallery(data) {
      let d = { ...data };

      if (!!d.video_single?.videos?.length) {
        if (!d.hasOwnProperty("video_gallery"))
          d.video_gallery = [
            {
              name: d.video_single.name || this.$t("video_gallery"),
              images: d.video_single.videos,
            },
          ];
        else
          d.video_gallery.push({
            name: d.video_single.name || this.$t("video_gallery"),
            images: d.video_single.videos,
          });
      } else if (!d.hasOwnProperty("video_gallery"))
        d.video_gallery = [
          {
            name: this.$t("video_gallery"),
            images: [],
          },
        ];
      if (!!d.video_single) delete d.video_single;
      return d;
    },
    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      this.errors = {};

      const currentLang = this.currentEditingLang; // || this.data.langs?.source_lang || "fa";
      const sourceLang = this.data.langs?.source_lang || "fa";
      const data = new URLSearchParams();
      data.append("type", "visitcardpro");
      data.append("qrType", "dynamic");
      data.append("title", this.res.title);
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("qr_id", this.res.qrId);
      this.data.language = this.defaultLang || getLanguageCookie() || "fa";
      data.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.data,
          orders: this.orders,
        }),
      );

      if (currentLang === sourceLang) {
        return this.saveToMainQr(data, final);
      } else {
        let content = {
          data: {
            data: this.data,
            theme: this.theme,
            orders: this.orders,
          },
        };
        return this.saveToLangFtp(currentLang, final, content);
      }
    },
    saveToMainQr(data, final) {
      return this.$api
        .put("/v1/testQr/update", data, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then(() => {
          if(final || !this.AutoSave)
          this.$toast.success(this.$t("visit_card_edited_successfully"));
          if (final) {    this.resetToDefaultLanguage();
        this.goto("qr/list");}
        })
        .catch((err) => this.handleError(err))
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
          if(final){
            this.resetToDefaultLanguage();
            this.goto("qr/list");
          }
        });
    },
    saveToLangFtp(lang, final, content) {
      const allLangs_1 = [this.defaultLang || "fa", ...this.alllangs];

      return this.$api
        .post(`/v1/testQr/update-lang-data/${this.createQrID}`, {
          lang: lang,
          data: content,
          langs: allLangs_1,
        })
        .then(() => {
          this.$toast.success(this.$t("language.saved"));
          if (final) {
            this.resetToDefaultLanguage();
            this.goto("qr/list");}
        })
        .catch((err) => this.handleError(err))
        .finally(() => (this.loading = false));
    },
  },
};
</script>
<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 4;
}
</style>
